{
  "uigNews": {
    "more": "Meer",
    "widgetTitle": "News",
    "widgetHeaderMore": "Meer"
  }
}
